// Generated catalog thumbnails/posters (see backend/scripts/generate_prompt_thumbnails.js).
export const CATALOG_COVER_WIDTH = 1536;
export const CATALOG_COVER_HEIGHT = 1024;
export const CATALOG_COVER_ASPECT = CATALOG_COVER_WIDTH / CATALOG_COVER_HEIGHT; // 3:2
